<label
  class="w-full px-5 py-4 rounded-full border-2 border-slate-300 justify-start items-center gap-4 flex relative"
  [ngClass]="
    !isDelivery
      ? 'focus-within:border-primary-500'
      : 'focus-within:border-secondary-500'
  "
>
  <input
    class="w-full outline-none peer order-1"
    [placeholder]="placeholder"
    [(ngModel)]="term"
  />
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    class="stroke-slate-300 peer-focus:stroke-primary-500 stroke-2"
    [ngClass]="
      !isDelivery
        ? 'peer-focus:stroke-primary-500'
        : 'peer-focus:stroke-secondary-500'
    "
  >
    <path
      d="M7.2593 12.9456C10.5321 12.9456 13.1852 10.2925 13.1852 7.01968C13.1852 3.74688 10.5321 1.09375 7.2593 1.09375C3.9865 1.09375 1.33337 3.74688 1.33337 7.01968C1.33337 10.2925 3.9865 12.9456 7.2593 12.9456Z"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.6666 14.4273L11.4443 11.2051"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    class="order-2 cursor-pointer"
    (click)="term = ''; $event.stopPropagation(); $event.preventDefault()"
    *ngIf="term"
  >
    <path
      d="M16.0306 9.53063L13.5603 12L16.0306 14.4694C16.1003 14.5391 16.1556 14.6218 16.1933 14.7128C16.231 14.8039 16.2504 14.9015 16.2504 15C16.2504 15.0985 16.231 15.1961 16.1933 15.2872C16.1556 15.3782 16.1003 15.4609 16.0306 15.5306C15.9609 15.6003 15.8782 15.6556 15.7872 15.6933C15.6961 15.731 15.5986 15.7504 15.5 15.7504C15.4015 15.7504 15.3039 15.731 15.2128 15.6933C15.1218 15.6556 15.0391 15.6003 14.9694 15.5306L12.5 13.0603L10.0306 15.5306C9.96095 15.6003 9.87822 15.6556 9.78718 15.6933C9.69613 15.731 9.59855 15.7504 9.5 15.7504C9.40146 15.7504 9.30388 15.731 9.21283 15.6933C9.12179 15.6556 9.03906 15.6003 8.96938 15.5306C8.8997 15.4609 8.84442 15.3782 8.80671 15.2872C8.769 15.1961 8.74959 15.0985 8.74959 15C8.74959 14.9015 8.769 14.8039 8.80671 14.7128C8.84442 14.6218 8.8997 14.5391 8.96938 14.4694L11.4397 12L8.96938 9.53063C8.82865 9.38989 8.74959 9.19902 8.74959 9C8.74959 8.80098 8.82865 8.61011 8.96938 8.46937C9.11011 8.32864 9.30098 8.24958 9.5 8.24958C9.69903 8.24958 9.8899 8.32864 10.0306 8.46937L12.5 10.9397L14.9694 8.46937C15.0391 8.39969 15.1218 8.34442 15.2128 8.3067C15.3039 8.26899 15.4015 8.24958 15.5 8.24958C15.5986 8.24958 15.6961 8.26899 15.7872 8.3067C15.8782 8.34442 15.9609 8.39969 16.0306 8.46937C16.1003 8.53906 16.1556 8.62178 16.1933 8.71283C16.231 8.80387 16.2504 8.90145 16.2504 9C16.2504 9.09855 16.231 9.19613 16.1933 9.28717C16.1556 9.37822 16.1003 9.46094 16.0306 9.53063ZM22.25 12C22.25 13.9284 21.6782 15.8134 20.6068 17.4168C19.5355 19.0202 18.0127 20.2699 16.2312 21.0078C14.4496 21.7458 12.4892 21.9389 10.5979 21.5627C8.70656 21.1865 6.96928 20.2579 5.60571 18.8943C4.24215 17.5307 3.31355 15.7934 2.93735 13.9021C2.56114 12.0108 2.75422 10.0504 3.49218 8.26884C4.23013 6.48726 5.47982 4.96451 7.08319 3.89317C8.68657 2.82183 10.5716 2.25 12.5 2.25C15.085 2.25273 17.5634 3.28084 19.3913 5.10872C21.2192 6.93661 22.2473 9.41498 22.25 12ZM20.75 12C20.75 10.3683 20.2661 8.77325 19.3596 7.41655C18.4531 6.05984 17.1646 5.00242 15.6571 4.37799C14.1497 3.75357 12.4909 3.59019 10.8905 3.90852C9.29017 4.22685 7.82016 5.01259 6.66637 6.16637C5.51259 7.32015 4.72685 8.79016 4.40853 10.3905C4.0902 11.9908 4.25358 13.6496 4.878 15.1571C5.50242 16.6646 6.55984 17.9531 7.91655 18.8596C9.27326 19.7661 10.8683 20.25 12.5 20.25C14.6873 20.2475 16.7843 19.3775 18.3309 17.8309C19.8775 16.2843 20.7475 14.1873 20.75 12Z"
      fill="#64748B"
    />
  </svg>
</label>
